"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TravelRuleDepositModalContainer["default"];
  }
});
var _TravelRuleDepositModalContainer = _interopRequireDefault(require("./TravelRuleDepositModalContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }